/**
 * Central Books Content Registry
 * 
 * This file auto-exports all book configurations and chapters.
 * To add a new book, create a folder with config.js and chapters.js,
 * then add the import/export here.
 */

// Import all book modules
import * as songOfRoland from './SongOfRoland';
import * as divineComedy from './DivineComedy';
import * as donQuixote from './DonQuixote';
import * as lais from './Lais';
import * as iliad from './Iliad';
import * as odyssey from './Odyssey';
import * as antigone from './Antigone';
import * as oedipus from './Oedipus';

// Export individual books
export { songOfRoland, divineComedy, donQuixote, lais, iliad, odyssey, antigone, oedipus };

// Collect all book configs into a single object
export const allBooks = {
  SongOfRoland: songOfRoland,
  DivineComedy: divineComedy,
  DonQuixote: donQuixote,
  Lais: lais,
  Iliad: iliad,
  Odyssey: odyssey,
  Antigone: antigone,
  Oedipus: oedipus
};

// Get all configs as an array
export const getAllConfigs = () => 
  Object.values(allBooks).map(book => book.config);

// Get config by book ID
export const getConfigById = (bookId) => 
  allBooks[bookId]?.config || null;

// Get chapters by book ID  
export const getChaptersById = (bookId) => 
  allBooks[bookId]?.chapters || [];

// Get all book IDs
export const getBookIds = () => Object.keys(allBooks);

export default allBooks;
